export default "__VITE_ASSET__Dxqquev5__"